import axios from "../../axios";

const header = (token) => ({
  headers: {
    Authorization: "Bearer " + token
  }
});

const baseUrl = () => process.env.VUE_APP_API_BASE_URL + '/api';

export default {
  list(token, params = {}) {
    axios.defaults.baseURL = `${baseUrl()}/notifications`;
    return axios.get('', { params, ...header(token) });
  },

  markAsRead(token, payload = {}) {
    axios.defaults.baseURL = `${baseUrl()}/notifications/read`;
    return axios.post('', payload, header(token));
  }
}
